import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function ConfirmModal({ show, title, body, confirmLabel, confirmVariant, onConfirm, onCancel }) {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant={confirmVariant || 'danger'} onClick={onConfirm}>
                    {confirmLabel || 'Confirm'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmModal;
